import { useEffect } from 'react';

export const useComponentDidMount = (onMountHandler: Function) => {
  useEffect(() => {
    onMountHandler();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export const useComponentWillUnmount = (onUnMountHandler: Function) => {
  useEffect(() => () => {
    onUnMountHandler();
  });
};
